import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelText as _vModelText, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/filterIcon_Disabled.svg'
import _imports_1 from '@/assets/filter.svg'
import _imports_2 from '@/assets/cancel.svg'


const _hoisted_1 = { class: "pt-3 pl-5 pr-5 overflow-x-hidden" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = {
  key: 0,
  class: "row w-full justify-between flex"
}
const _hoisted_4 = { class: "title flex items-center" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = { key: 4 }
const _hoisted_10 = { key: 5 }
const _hoisted_11 = { key: 6 }
const _hoisted_12 = { class: "flex items-center gap-3" }
const _hoisted_13 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_14 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_15 = { class: "mt-6" }
const _hoisted_16 = { class: "tableCornerRadius bg-white" }
const _hoisted_17 = { class: "table-container" }
const _hoisted_18 = { class: "header cursor-pointer th1" }
const _hoisted_19 = { class: "w-4" }
const _hoisted_20 = ["disabled", "checked"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { key: 2 }
const _hoisted_25 = { key: 3 }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = ["onUpdate:modelValue"]
const _hoisted_28 = ["value"]
const _hoisted_29 = ["onUpdate:modelValue"]
const _hoisted_30 = ["value"]
const _hoisted_31 = ["onUpdate:modelValue"]
const _hoisted_32 = ["value"]
const _hoisted_33 = ["onUpdate:modelValue"]
const _hoisted_34 = ["value"]
const _hoisted_35 = ["onUpdate:modelValue"]
const _hoisted_36 = ["value"]
const _hoisted_37 = ["onUpdate:modelValue"]
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { class: "cursor-pointer rowHeight" }
const _hoisted_40 = ["colspan"]
const _hoisted_41 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { class: "cursor-pointer rowHeight" }
const _hoisted_44 = ["colspan"]
const _hoisted_45 = {
  key: 2,
  class: "nonEmptyTable"
}
const _hoisted_46 = { key: 0 }
const _hoisted_47 = ["disabled", "value", "onChange"]
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { class: "relative w-28 regular pl-2" }
const _hoisted_51 = ["onMousemove"]
const _hoisted_52 = { key: 1 }
const _hoisted_53 = { key: 0 }
const _hoisted_54 = { key: 1 }
const _hoisted_55 = { key: 2 }
const _hoisted_56 = { key: 0 }
const _hoisted_57 = { key: 3 }
const _hoisted_58 = { class: "flex rounded w-28 items-center regular text-xs tip" }
const _hoisted_59 = { key: 0 }
const _hoisted_60 = { class: "flex w-28 items-center justify-center regular" }
const _hoisted_61 = { key: 4 }
const _hoisted_62 = { class: "table-ellipsis" }
const _hoisted_63 = ["onMousemove"]
const _hoisted_64 = { key: 0 }
const _hoisted_65 = { class: "overflow-x-hidden overflow-y-auto fixed inset-0 z-index justify-end items-start flex" }
const _hoisted_66 = { class: "relative w-full max-w-xl" }
const _hoisted_67 = { class: "border-0 rounded relative flex flex-col w-full bg-white risksAcceptance h-screen" }
const _hoisted_68 = { class: "flex items-center justify-between p-3 rounded popupheadingcontainer" }
const _hoisted_69 = { class: "flex flex-col h-full" }
const _hoisted_70 = { class: "flex-1 overflow-auto" }
const _hoisted_71 = { class: "flex-1 overflow-auto" }
const _hoisted_72 = { class: "impactcontainer popupbodycontainer" }
const _hoisted_73 = { class: "formcontainer flex flex-col" }
const _hoisted_74 = { class: "row flex flex-col" }
const _hoisted_75 = { class: "upperspacing" }
const _hoisted_76 = {
  key: 0,
  class: "controllabel"
}
const _hoisted_77 = {
  key: 1,
  class: "controllabel"
}
const _hoisted_78 = {
  key: 2,
  class: "controllabel"
}
const _hoisted_79 = { class: "text-xs flex flex-wrap" }
const _hoisted_80 = {
  key: 0,
  class: "border-b border-solid border-lightgrey upperspacing"
}
const _hoisted_81 = {
  key: 1,
  class: "w-full upperspacing"
}
const _hoisted_82 = {
  key: 0,
  class: "controllabel"
}
const _hoisted_83 = {
  key: 1,
  class: "controllabel"
}
const _hoisted_84 = {
  key: 2,
  class: "controllabel"
}
const _hoisted_85 = {
  key: 3,
  class: "controllabel"
}
const _hoisted_86 = {
  key: 4,
  class: "controllabel"
}
const _hoisted_87 = {
  key: 5,
  class: "controllabel"
}
const _hoisted_88 = {
  key: 6,
  class: "text-red-500"
}
const _hoisted_89 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_90 = {
  key: 2,
  class: "upperspacing"
}
const _hoisted_91 = { class: "w-1/2" }
const _hoisted_92 = { class: "row flex flex-col w-full" }
const _hoisted_93 = {
  key: 0,
  class: "w-full upperspacing"
}
const _hoisted_94 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_95 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_96 = {
  key: 0,
  class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5"
}
const _hoisted_97 = ["disabled"]
const _hoisted_98 = ["disabled"]
const _hoisted_99 = ["disabled"]
const _hoisted_100 = ["disabled"]
const _hoisted_101 = ["disabled"]
const _hoisted_102 = ["disabled"]
const _hoisted_103 = ["disabled"]
const _hoisted_104 = {
  key: 1,
  class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5"
}
const _hoisted_105 = ["disabled"]
const _hoisted_106 = ["disabled"]
const _hoisted_107 = {
  key: 0,
  class: "opacity-40 fixed inset-0 z-50 bg-black"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumb = _resolveComponent("breadCrumb")!
  const _component_dots_loader = _resolveComponent("dots-loader")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_Select = _resolveComponent("Select")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_breadCrumb, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
      ]),
      (_ctx.riskAcceptanceObj.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_ctx.thisScreen == 'Acceptance')
                ? (_openBlock(), _createElementBlock("h1", _hoisted_5, "Risk Acceptance - " + _toDisplayString(_ctx.riskAcceptanceObj[0]?.risk), 1))
                : _createCommentVNode("", true),
              (_ctx.thisScreen == 'reset')
                ? (_openBlock(), _createElementBlock("h1", _hoisted_6, "Risk Reset - " + _toDisplayString(_ctx.riskAcceptanceObj[0]?.risk), 1))
                : _createCommentVNode("", true),
              (_ctx.thisScreen == 'Mitigate')
                ? (_openBlock(), _createElementBlock("h1", _hoisted_7, "Risk Mitigate - " + _toDisplayString(_ctx.riskAcceptanceObj[0]?.risk), 1))
                : _createCommentVNode("", true),
              (_ctx.thisScreen == 'delete')
                ? (_openBlock(), _createElementBlock("h1", _hoisted_8, "Risk Invalid - " + _toDisplayString(_ctx.riskAcceptanceObj[0]?.risk), 1))
                : _createCommentVNode("", true),
              (_ctx.thisScreen=='priority')
                ? (_openBlock(), _createElementBlock("h1", _hoisted_9, "Risk Priority-" + _toDisplayString(_ctx.riskAcceptanceObj[0]?.risk), 1))
                : _createCommentVNode("", true),
              (_ctx.thisScreen == 'Avoid')
                ? (_openBlock(), _createElementBlock("h1", _hoisted_10, "Risk Avoid - " + _toDisplayString(_ctx.riskAcceptanceObj[0]?.risk), 1))
                : _createCommentVNode("", true),
              (_ctx.thisScreen == 'Transfer')
                ? (_openBlock(), _createElementBlock("h1", _hoisted_11, "Risk Transfer - " + _toDisplayString(_ctx.riskAcceptanceObj[0]?.risk), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("button", {
                class: _normalizeClass(_ctx.defNotEqual ? 'btnprimary opacity-100' : 'btndisabled pointer-events-none'),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.applyInfo()))
              }, "Apply", 2),
              _createElementVNode("button", {
                class: _normalizeClass(_ctx.defNotEqual ? 'btnprimary opacity-100' : 'btndisabled pointer-events-none'),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cancelInfos()))
              }, "Reset", 2),
              _createElementVNode("button", {
                class: _normalizeClass(["flex", _ctx.tableRow.length == 0?'btndisabled pointer-events-none':'filterButton']),
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
              }, [
                (_ctx.tableRow.length == 0)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_13))
                  : (_openBlock(), _createElementBlock("img", _hoisted_14)),
                _cache[22] || (_cache[22] = _createTextVNode(" Filters "))
              ], 2)
            ])
          ]))
        : _createCommentVNode("", true),
      _cache[36] || (_cache[36] = _createElementVNode("div", { class: "mt-6" }, [
        _createElementVNode("div", { class: "text-xs" }, " This course helps you to Understand current data protection legislation and underlying principles. It also helps you to Understand what Privacy Awareness is, what PII is, PII Processing, Individual Rights, Cross Border Transfers, PII Breaches, Privacy By Design. This course helps you to understand what Information Security is, awareness on information security, different kinds of security breaches happening in daily life, physical security, email security, Knowing your responsibilities when dealing with Information Security. ")
      ], -1)),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("table", null, [
              _createElementVNode("thead", null, [
                _createElementVNode("th", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      disabled: _ctx.isAllSelected() && (_ctx.thisScreen == 'Acceptance'||_ctx.thisScreen=='Mitigate'),
                      class: "checkbox hidden cursor-pointer",
                      checked: _ctx.isParentSelected(),
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectAll) = $event)),
                      onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectAllOptions($event)))
                    }, null, 40, _hoisted_20), [
                      [_vModelCheckbox, _ctx.selectAll]
                    ])
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (column) => {
                  return (_openBlock(), _createElementBlock("th", {
                    scope: "col",
                    key: column,
                    class: _normalizeClass(["bg-white cursor-pointer capitalize", _ctx.getColumnHeadWidth(column)]),
                    onClick: ($event: any) => (_ctx.sort(column))
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["flex", _ctx.bindClassForColumn(column)])
                    }, [
                      (column == 'orgName')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, "Organization Name"))
                        : (column == 'processName')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, "Process Name"))
                          : (column == 'systemName')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, "System Name"))
                            : (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(column), 1)),
                      _createElementVNode("div", {
                        class: _normalizeClass(["sort cursor-pointer", _ctx.className == column ? _ctx.classSort : 'opacity-50'])
                      }, null, 2)
                    ], 2)
                  ], 10, _hoisted_21))
                }), 128)),
                (_ctx.showFilters)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_26, [
                      _cache[28] || (_cache[28] = _createElementVNode("td", null, null, -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (name) => {
                        return (_openBlock(), _createElementBlock("td", {
                          class: "bg-white",
                          key: name
                        }, [
                          (name=='severity')
                            ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                key: 0,
                                class: _normalizeClass(["widthForSelect filter-font-size", _ctx.filterDummy[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                "onUpdate:modelValue": ($event: any) => ((_ctx.filterDummy[name]) = $event)
                              }, [
                                _cache[23] || (_cache[23] = _createElementVNode("option", {
                                  value: "",
                                  selected: "",
                                  disabled: "",
                                  hidden: ""
                                }, "Select", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbSeverity, (option) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    class: "optionColors",
                                    key: option,
                                    value: option.value
                                  }, _toDisplayString(option.key), 9, _hoisted_28))
                                }), 128))
                              ], 10, _hoisted_27)), [
                                [_vModelSelect, _ctx.filterDummy[name]]
                              ])
                            : (name=='impact')
                              ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                  key: 1,
                                  class: _normalizeClass(["widthForSelect filter-font-size", _ctx.filterDummy[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.filterDummy[name]) = $event)
                                }, [
                                  _cache[24] || (_cache[24] = _createElementVNode("option", {
                                    value: "",
                                    selected: "",
                                    disabled: "",
                                    hidden: ""
                                  }, "Select", -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbOverAllImpact, (option) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      class: "optionColors",
                                      key: option,
                                      value: option.value
                                    }, _toDisplayString(option.key), 9, _hoisted_30))
                                  }), 128))
                                ], 10, _hoisted_29)), [
                                  [_vModelSelect, _ctx.filterDummy[name]]
                                ])
                              : (name=='likelihood')
                                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                    key: 2,
                                    class: _normalizeClass(["widthForSelect filter-font-size", _ctx.filterDummy[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.filterDummy[name]) = $event)
                                  }, [
                                    _cache[25] || (_cache[25] = _createElementVNode("option", {
                                      value: "",
                                      selected: "",
                                      disabled: "",
                                      hidden: ""
                                    }, "Select", -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbLikelihood, (option) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        class: "optionColors",
                                        key: option,
                                        value: option.value
                                      }, _toDisplayString(option.key), 9, _hoisted_32))
                                    }), 128))
                                  ], 10, _hoisted_31)), [
                                    [_vModelSelect, _ctx.filterDummy[name]]
                                  ])
                                : (name=='priority')
                                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                      key: 3,
                                      class: _normalizeClass(["widthForSelect filter-font-size", _ctx.filterDummy[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                      "onUpdate:modelValue": ($event: any) => ((_ctx.filterDummy[name]) = $event)
                                    }, [
                                      _cache[26] || (_cache[26] = _createElementVNode("option", {
                                        value: "",
                                        selected: "",
                                        disabled: "",
                                        hidden: ""
                                      }, "Select", -1)),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dbPriority, (option) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          class: "optionColors",
                                          key: option,
                                          value: option.value
                                        }, _toDisplayString(option.key), 9, _hoisted_34))
                                      }), 128))
                                    ], 10, _hoisted_33)), [
                                      [_vModelSelect, _ctx.filterDummy[name]]
                                    ])
                                  : (name=='status')
                                    ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                        key: 4,
                                        class: _normalizeClass(["widthForSelect filter-font-size", _ctx.filterDummy[name] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']),
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.filterDummy[name]) = $event)
                                      }, [
                                        _cache[27] || (_cache[27] = _createElementVNode("option", {
                                          value: "",
                                          selected: "",
                                          disabled: "",
                                          hidden: ""
                                        }, "Select", -1)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.risksStatusValues, (option) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            class: "optionColors",
                                            key: option,
                                            value: option.id
                                          }, _toDisplayString(option.value), 9, _hoisted_36))
                                        }), 128))
                                      ], 10, _hoisted_35)), [
                                        [_vModelSelect, _ctx.filterDummy[name]]
                                      ])
                                    : _withDirectives((_openBlock(), _createElementBlock("input", {
                                        key: 5,
                                        type: "text",
                                        placeholder: "Search",
                                        class: "searchForInputBoxStyling filter-font-size",
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.filterDummy[name]) = $event)
                                      }, null, 8, _hoisted_37)), [
                                        [_vModelText, _ctx.filterDummy[name]]
                                      ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.dataLoading == true)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_38, [
                    _createElementVNode("tr", _hoisted_39, [
                      _createElementVNode("td", {
                        class: "relative h-5",
                        colspan: _ctx.columnNames.size
                      }, [
                        _createElementVNode("div", _hoisted_41, [
                          _createVNode(_component_dots_loader)
                        ])
                      ], 8, _hoisted_40)
                    ])
                  ]))
                : (_ctx.sortedData.length==0)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_42, [
                      _createElementVNode("tr", _hoisted_43, [
                        _createElementVNode("td", {
                          class: "relative h-10",
                          colspan: _ctx.columnNames.size
                        }, _cache[29] || (_cache[29] = [
                          _createElementVNode("div", { class: "flex justify-center" }, [
                            _createElementVNode("p", { class: "text-xs font-normal" }, "No Records Found")
                          ], -1)
                        ]), 8, _hoisted_44)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("tbody", _hoisted_45, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedData, (row, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: row,
                          class: "cursor-pointer rowHeight"
                        }, [
                          _createElementVNode("td", {
                            onMouseout: _cache[6] || (_cache[6] = ($event: any) => (_ctx.doFalse()))
                          }, [
                            (row.status != 10408)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                  _withDirectives(_createElementVNode("input", {
                                    disabled: (row.status == 10403 && _ctx.thisScreen == 'Acceptance')||(row.status == 10403 && _ctx.thisScreen == 'Avoid')||(_ctx.thisScreen == 'Mitigate' && (row.status == 10405||row.status == 10403)),
                                    class: "checkbox cursor-pointer",
                                    type: "checkbox",
                                    value: row,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedItems) = $event)),
                                    onChange: ($event: any) => (_ctx.changeInfo(row, $event))
                                  }, null, 40, _hoisted_47), [
                                    [_vModelCheckbox, _ctx.selectedItems]
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (row.status == 10408)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_48, _cache[30] || (_cache[30] = [
                                  _createElementVNode("div", { class: "checkbox bg-lightgrey flex items-center justify-center cursor-not-allowed" }, [
                                    _createElementVNode("div", { class: "border-disabledgrey horizontalCheckBox w-1/2" })
                                  ], -1)
                                ])))
                              : _createCommentVNode("", true)
                          ], 32),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (column) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: column,
                              onMouseout: _cache[7] || (_cache[7] = ($event: any) => (_ctx.doFalse())),
                              class: "whitespace-nowrap cursor-pointer relative"
                            }, [
                              (column == 'severity')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                    _createElementVNode("div", _hoisted_50, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["flex items-center justify-center rounded-full ml-2 w-5 h-5", _ctx.colorPropBg('border',row.severity)]),
                                        onMousemove: ($event: any) => (_ctx.toolTip(column, $event, index, row, 'circleButton'))
                                      }, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["severityCircle rounded-full", _ctx.colorPropBg('circle',row.severity)])
                                        }, null, 2)
                                      ], 42, _hoisted_51)
                                    ])
                                  ]))
                                : (column == 'impact' || column == 'likelihood')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24", _ctx.colorRiskBg(row[column])])
                                      }, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(_ctx.colorRiskText(row[column]))
                                        }, [
                                          (column == 'impact')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(_ctx.dbOverAllImpact.find((l) => {
                                                    return l?.value == row[column];
                                                })?.key), 1))
                                            : (column == 'likelihood')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_54, _toDisplayString(_ctx.dbLikelihood.find((l) => {
                                                    return l?.value == row[column];
                                                })?.key), 1))
                                              : _createCommentVNode("", true)
                                        ], 2)
                                      ], 2)
                                    ]))
                                  : (column == 'priority')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24", _ctx.colorRiskBg(row[column])])
                                        }, [
                                          _createElementVNode("div", {
                                            class: _normalizeClass(_ctx.colorRiskText(row[column]))
                                          }, [
                                            (column == 'priority')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_56, _toDisplayString(_ctx.dbPriority.find((l) => {
                                                    return l?.value == row[column];
                                                })?.key), 1))
                                              : _createCommentVNode("", true)
                                          ], 2)
                                        ], 2)
                                      ]))
                                    : (column == 'status')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                          _createElementVNode("div", {
                                            class: _normalizeClass(["flex items-center relative rounded regular text-xs w-24 h-5", _ctx.colorStatusText(row.status)])
                                          }, [
                                            _createElementVNode("div", {
                                              class: _normalizeClass(["w-full h-full absolute rounded", _ctx.colorStatusBg(row.status)])
                                            }, null, 2),
                                            _createElementVNode("div", _hoisted_58, [
                                              (!isNaN(row.status))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                                    _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.risksStatusValues.find((l) => {
                                                        return l.id == row.status;
                                                    }).value), 1)
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ])
                                          ], 2)
                                        ]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                          _createElementVNode("div", _hoisted_62, [
                                            _createElementVNode("div", {
                                              onMousemove: ($event: any) => (_ctx.toolTip(column, $event, index, row, 'text'))
                                            }, _toDisplayString(row[column]), 41, _hoisted_63)
                                          ])
                                        ]))
                            ], 32))
                          }), 128))
                        ]))
                      }), 128))
                    ]))
            ])
          ]),
          _createVNode(_component_pagination, {
            dynamicPagination: _ctx.dynamicPagination,
            onCurrentPageUpdate: _ctx.paginationUpdations,
            sortedData: _ctx.sortedData
          }, null, 8, ["dynamicPagination", "onCurrentPageUpdate", "sortedData"])
        ]),
        (_ctx.toolTipActive)
          ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
              _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.applyPopup)
        ? (_openBlock(), _createBlock(_component_popup, {
            key: 1,
            class: "applyPopup",
            popUp: _ctx.applyPopup
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("div", _hoisted_68, [
                      _createElementVNode("h1", null, _toDisplayString(_ctx.riskAcceptanceObj[0].risk), 1),
                      _createElementVNode("button", {
                        class: "p-1 ml-auto float-right text-3xl leading-none font-semibold outline-none focus:outline-none",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onCrossbtn()))
                      }, _cache[31] || (_cache[31] = [
                        _createElementVNode("img", {
                          src: _imports_2,
                          class: "h-5 w-5 cursor-pointer"
                        }, null, -1)
                      ]))
                    ]),
                    _cache[35] || (_cache[35] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey ml-4 mr-4" }, null, -1)),
                    _createElementVNode("div", _hoisted_69, [
                      _createElementVNode("div", _hoisted_70, [
                        _createElementVNode("div", _hoisted_71, [
                          _createElementVNode("div", _hoisted_72, [
                            _createElementVNode("div", _hoisted_73, [
                              _createElementVNode("div", _hoisted_74, [
                                _createElementVNode("div", _hoisted_75, [
                                  (_ctx.systemHead)
                                    ? (_openBlock(), _createElementBlock("label", _hoisted_76, "Systems"))
                                    : _createCommentVNode("", true),
                                  (_ctx.processHead)
                                    ? (_openBlock(), _createElementBlock("label", _hoisted_77, "Process"))
                                    : _createCommentVNode("", true),
                                  (_ctx.organizationHead)
                                    ? (_openBlock(), _createElementBlock("label", _hoisted_78, "Organization"))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_79, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedSystemsForAccept, (system) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: system,
                                        class: "mr-2 mb-2 bg-primary text-white px-2 py-1 rounded textStyle"
                                      }, _toDisplayString(_ctx.mappedSystemsOptions.find(option => option.value === system)?.label || "No system selected"), 1))
                                    }), 128))
                                  ])
                                ]),
                                (_ctx.thisScreen=='Acceptance'||_ctx.thisScreen=='reset'||_ctx.thisScreen=='delete'||_ctx.thisScreen=='Avoid'||_ctx.thisScreen=='Transfer'|| _ctx.thisScreen == 'Mitigate')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_80))
                                  : _createCommentVNode("", true),
                                (_ctx.thisScreen=='Acceptance'||_ctx.thisScreen=='reset'||_ctx.thisScreen=='delete'||_ctx.thisScreen=='Avoid'||_ctx.thisScreen=='Transfer'||_ctx.thisScreen == 'Mitigate')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                                      (_ctx.thisScreen == 'Acceptance')
                                        ? (_openBlock(), _createElementBlock("label", _hoisted_82, "Reason for Accepting Risk / Justification"))
                                        : _createCommentVNode("", true),
                                      (_ctx.thisScreen == 'Mitigate')
                                        ? (_openBlock(), _createElementBlock("label", _hoisted_83, "Reason for Mitigating Risk / Justification"))
                                        : _createCommentVNode("", true),
                                      (_ctx.thisScreen == 'reset')
                                        ? (_openBlock(), _createElementBlock("label", _hoisted_84, "Reason for Reset Risk / Justification"))
                                        : _createCommentVNode("", true),
                                      (_ctx.thisScreen == 'delete')
                                        ? (_openBlock(), _createElementBlock("label", _hoisted_85, "Reason for Delete Risk / Justification"))
                                        : _createCommentVNode("", true),
                                      (_ctx.thisScreen == 'Avoid')
                                        ? (_openBlock(), _createElementBlock("label", _hoisted_86, "Reason for Avoid Risk"))
                                        : _createCommentVNode("", true),
                                      (_ctx.thisScreen == 'Transfer')
                                        ? (_openBlock(), _createElementBlock("label", _hoisted_87, "Reason for Transfer Risk"))
                                        : _createCommentVNode("", true),
                                      _withDirectives(_createElementVNode("textarea", {
                                        type: "text",
                                        class: _normalizeClass(["inputboxstyling h-20 max-h-48", {
                                                    'is-invalid': _ctx.v$.applyObj.comments.$error
                                                }]),
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.applyObj.comments) = $event)),
                                        placeholder: "Reason / Justification",
                                        onKeyup: _cache[10] || (_cache[10] = ($event: any) => (_ctx.changePopup(_ctx.applyObj)))
                                      }, null, 34), [
                                        [
                                          _vModelText,
                                          _ctx.applyObj.comments,
                                          void 0,
                                          { trim: true }
                                        ]
                                      ]),
                                      (_ctx.v$.applyObj.comments.$error)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                                            (_ctx.v$.applyObj.comments.required.$invalid)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_89, "Required"))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : (_ctx.thisScreen=='priority')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                                        _createElementVNode("div", _hoisted_91, [
                                          _cache[32] || (_cache[32] = _createElementVNode("label", { class: "controllabel" }, "Priority", -1)),
                                          _createVNode(_component_Select, {
                                            modelValue: _ctx.selectedPriorityKey,
                                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.selectedPriorityKey) = $event)),
                                            options: _ctx.dbPriority,
                                            optionLabel: "key",
                                            optionValue: "value",
                                            onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.priorityChange(_ctx.selectedPriorityKey))),
                                            placeholder: "Priority",
                                            class: "custom-multiselect w-full"
                                          }, null, 8, ["modelValue", "options"])
                                        ]),
                                        _createElementVNode("div", null, [
                                          _createElementVNode("div", _hoisted_92, [
                                            (_ctx.priorityDataChange)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                                                  _cache[33] || (_cache[33] = _createElementVNode("label", {
                                                    for: "Risk",
                                                    class: "controllabel"
                                                  }, "Justification", -1)),
                                                  _withDirectives(_createElementVNode("textarea", {
                                                    type: "text",
                                                    class: _normalizeClass(["inputboxstyling",  {
                                                'is-invalid': _ctx.v$.riskAcceptanceObj[0].justification.$error
                                            }]),
                                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.riskAcceptanceObj[0].justification) = $event)),
                                                    placeholder: "Justification"
                                                  }, null, 2), [
                                                    [
                                                      _vModelText,
                                                      _ctx.riskAcceptanceObj[0].justification,
                                                      void 0,
                                                      { trim: true }
                                                    ]
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true),
                                            (_ctx.v$.riskAcceptanceObj[0].justification.$error)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                                                  (_ctx.v$.riskAcceptanceObj[0].justification.required.$invalid)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_95, "justification required"))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _cache[34] || (_cache[34] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey ml-4 mr-4" }, null, -1)),
                        (_ctx.thisScreen=='Acceptance'||_ctx.thisScreen=='reset'||_ctx.thisScreen=='delete'||_ctx.thisScreen=='Avoid'||_ctx.thisScreen=='Transfer' ||_ctx.thisScreen=='Mitigate')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                              _createElementVNode("button", {
                                disabled: _ctx.clickOnButton,
                                class: _normalizeClass([(_ctx.selectedSystemsForAccept.length || _ctx.defEqual) && _ctx.applyObj.comments!=''? 'btnprimary opacity-100' : 'btndisabled pointer-events-none', "mr-3"]),
                                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onCancelbtn()))
                              }, "Reset", 10, _hoisted_97),
                              (_ctx.thisScreen == 'Acceptance')
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    disabled: _ctx.clickOnButton,
                                    class: _normalizeClass((_ctx.selectedSystemsForAccept.length || _ctx.defEqual) && _ctx.applyObj.comments!='' ? 'btnprimary opacity-100' : 'btndisabled pointer-events-none'),
                                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.createTaskForAction(_ctx.applyObj,10403)))
                                  }, "Apply", 10, _hoisted_98))
                                : _createCommentVNode("", true),
                              (_ctx.thisScreen == 'Mitigate')
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    disabled: _ctx.clickOnButton,
                                    class: _normalizeClass((_ctx.selectedSystemsForAccept.length || _ctx.defEqual) && _ctx.applyObj.comments!='' ? 'btnprimary opacity-100' : 'btndisabled pointer-events-none'),
                                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.createTaskForAction(_ctx.applyObj,10405)))
                                  }, "Apply", 10, _hoisted_99))
                                : _createCommentVNode("", true),
                              (_ctx.thisScreen == 'reset')
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 2,
                                    disabled: _ctx.clickOnButton,
                                    class: _normalizeClass((_ctx.selectedSystemsForAccept.length || _ctx.defEqual) && _ctx.applyObj.comments!='' ? 'btnprimary opacity-100' : 'btndisabled pointer-events-none'),
                                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.createTaskForAction(_ctx.applyObj,10407)))
                                  }, "Apply", 10, _hoisted_100))
                                : _createCommentVNode("", true),
                              (_ctx.thisScreen == 'delete')
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 3,
                                    disabled: _ctx.clickOnButton,
                                    class: _normalizeClass((_ctx.selectedSystemsForAccept.length || _ctx.defEqual) && _ctx.applyObj.comments!='' ? 'btnprimary opacity-100' : 'btndisabled pointer-events-none'),
                                    onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.createTaskForAction(_ctx.applyObj,10404)))
                                  }, "Apply", 10, _hoisted_101))
                                : _createCommentVNode("", true),
                              (_ctx.thisScreen == 'Avoid')
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 4,
                                    disabled: _ctx.clickOnButton,
                                    class: _normalizeClass((_ctx.selectedSystemsForAccept.length || _ctx.defEqual) && _ctx.applyObj.comments!='' ? 'btnprimary opacity-100' : 'btndisabled pointer-events-none'),
                                    onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.createTaskForAction(_ctx.applyObj,10419)))
                                  }, "Apply", 10, _hoisted_102))
                                : _createCommentVNode("", true),
                              (_ctx.thisScreen == 'Transfer')
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 5,
                                    disabled: _ctx.clickOnButton,
                                    class: _normalizeClass((_ctx.selectedSystemsForAccept.length || _ctx.defEqual) && _ctx.applyObj.comments!='' ? 'btnprimary opacity-100' : 'btndisabled pointer-events-none')
                                  }, "Apply", 10, _hoisted_103))
                                : _createCommentVNode("", true)
                            ]))
                          : (_ctx.thisScreen=='priority')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                                _createElementVNode("button", {
                                  disabled: _ctx.clickOnButton,
                                  class: _normalizeClass(["btnprimary mr-1.5", (_ctx.priorityDataChange==true) ? 'btnprimary' : 'btndisabled pointer-events-none']),
                                  onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.cancelPriorityBtn()))
                                }, "Reset", 10, _hoisted_105),
                                _createElementVNode("button", {
                                  disabled: _ctx.clickOnButton,
                                  class: _normalizeClass((_ctx.priorityDataChange==true)? 'btnprimary' : 'btndisabled pointer-events-none'),
                                  onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.addOrUpdatePriority()))
                                }, "Save", 10, _hoisted_106)
                              ]))
                            : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["popUp"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showRiskAcceptanceModal || _ctx.applyPopup)
      ? (_openBlock(), _createElementBlock("div", _hoisted_107))
      : _createCommentVNode("", true)
  ], 64))
}